<div class="container mx-auto" (click)="openModal()">
  <div
    tabindex="0"
    class="max-w-xs mx-auto p-4 bg-white rounded-lg hover-effect border-gray flex flex-col items-center justify-center"
  >
    <button class="focus:outline-none" aria-label="Create group">
      <div class="flex items-center justify-center">
        <svg
          width="48px"
          height="48px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" fill="white" stroke="#0D0D0D" />
          <path
            d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1z"
            fill="#0D0D0D"
          />
        </svg>
      </div>
    </button>
    <div class="mt-4 text-xl">Create Group</div>
  </div>
</div>

<app-group-create-modal
  [isOpen]="isModalOpen"
  (closeModalRequested)="closeModal()"
></app-group-create-modal>
